<template>
  <div class="wrapper">
    <div id="project_amount_params">
      <div id="project_amount_selects">
        <div class="project_amount_select">
          <input id="all" type="radio" value=0 v-model="division" @change="changeData"/>
          <label for="all">Công ty</label>
        </div>
        <div class="project_amount_select">
          <input id="f1" type="radio" value=1 v-model="division" @change="changeData"/>
          <label for="f1">Khối PT1</label>
        </div>
        <div class="project_amount_select">
          <input id="f2" type="radio" value=2 v-model="division" @change="changeData"/>
          <label for="f2">Khối PT2</label>
        </div>
      </div>
      <div id="year_select">
        <select v-model="currentYear" @change="changeData">
          <option v-for="year in listYear" :value="year">{{ year }}</option>
        </select>
      </div>
    </div>
    <div id="project_amount_chart">
      <div style="width: 90%" @wheel.prevent="zoomIn">
        <v-chart
          :option="option"
          autoresize
          style="min-height: 650px; width: 100%"
          @click="onClickBarChart"
          @resize="resizeWidth"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {use} from "echarts/core";
import {CanvasRenderer} from "echarts/renderers";
import {BarChart} from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent
} from "echarts/components";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  TimelineComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent
]);
import {mapGetters, mapActions} from "vuex";
import {TimelineComponent} from 'echarts/components';

const colors = ['#01959E', '#5E495A', '#EA6057'];
const labels = ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6', 'Tháng 7', 'Tháng 8','Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'];

export default {
  name: "ProjectAmount",
  components: {
    VChart,
  },
  data() {
    return {
      division: 0, // 0: all, 1: division 1, 2: division 2
      type: 0, // 0: month, 1: session, 2: year
      labelMonth: labels,
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      quarters: [1, 2, 3, 4],
      labelYears: [],
      currentYear: new Date().getFullYear(),
      listYear: [],
      option: {
        barWidth: 50,
        color: colors,
        grid: {
          left: '3%',
          right: '0'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16,
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {show: false}
          }
        },
        legend: {
          textStyle: {
            fontFamily: 'Helvetica',
            fontSize: 16,
            fontWeight: 400,
            // verticalAlign: 'middle'
          },
          itemGap: 30,
          itemWidth: 20,
          itemHeight: 20,
          data: ['Maintain', 'Spot', 'Labo'],
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            },
            offset: 10,
            // prettier-ignore
            data: labels,
            nameTextStyle: {
              fontWeight: 500,
              fontSize: 16,
              fontFamily: 'Helvetica',
              color: '#303C54'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Số lượng',
            position: 'left',
            alignTicks: true,
            min: 0,
            max: 100,
            splitNumber: 10,
            axisLine: {
              show: true,
              lineStyle: {
                // color: colors[0]
              }
            },
            axisLabel: {
              formatter: '{value}'
            },
            nameTextStyle: {
              fontSize: 16,
              fontFamily: 'Helvetica',
            }
          },
        ],
        media: [
          {
            minWidth: '120%',
            minAspectRatio: 2
          }
        ],
        series: [
          {
            name: 'Maintain',
            data: [],
            type: 'bar',
            stack: 'x',
            label: {
              show: true,
              align: 'center',
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'sans-serif',
              color: '#FFFFFF',
              verticalAlign: 'top',
              position: 'insideTop',
              formatter: (param) => {
                return param.value > 2 ? param.value : '';
              }
            }
          },
          {
            name: 'Spot',
            data: [],
            type: 'bar',
            stack: 'x',
            label: {
              show: true,
              align: 'center',
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'sans-serif',
              color: '#FFFFFF',
              verticalAlign: 'top',
              position: 'insideTop',
              formatter: (param) => {
                return param.value > 2 ? param.value : '';
              }
            }
          },
          {
            name: 'Labo',
            data: [],
            type: 'bar',
            stack: 'x',
            label: {
              show: true,
              align: 'center',
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'sans-serif',
              color: '#FFFFFF',
              verticalAlign: 'top',
              position: 'insideTop',
              formatter: (param) => {
                return param.value > 2 ? param.value : '';
              }
            }
          }
        ]
      }
    };
  },
  async created() {
    await this.getData();
    await this.changeData();
  },
  mounted: function () {
    window.addEventListener('resize', this.resizeWidth);
  },
  computed: {
    ...mapGetters({
      project_overview_amount: "project/project_overview_amount",
    }),
  },

  methods: {
    ...mapActions("project", ["getOverviewProjectAmount"]),
    zoomIn(e) {
      if (e.deltaY > 0 && this.type < 2) {
        this.type++;
        this.changeData();
      } else if (e.deltaY < 0 && this.type > 0) {
        this.type--;
        this.changeData();
      }
    },
    changeData() {
      switch (this.type) {
        case 0:
          this.option.xAxis[0].data = this.labelMonth;
          let dataMaintainM = [];
          let dataSpotM = [];
          let dataLaboM = [];
          Object.entries(this.months).forEach((month, index) => {
            if (this.project_overview_amount['months'][this.currentYear][month[1]]
              && this.project_overview_amount['months'][this.currentYear][month[1]][3]
              && this.project_overview_amount['months'][this.currentYear][month[1]][3][this.division]) {
              dataMaintainM[index] = this.project_overview_amount['months'][this.currentYear][month[1]][3][this.division];
            } else {
              dataMaintainM[index] = 0;
            }

            if (this.project_overview_amount['months'][this.currentYear][month[1]]
              && this.project_overview_amount['months'][this.currentYear][month[1]][1]
              && this.project_overview_amount['months'][this.currentYear][month[1]][1][this.division]) {
              dataSpotM[index] = this.project_overview_amount['months'][this.currentYear][month[1]][1][this.division];
            } else {
              dataSpotM[index] = 0;
            }

            if (this.project_overview_amount['months'][this.currentYear][month[1]]
              && this.project_overview_amount['months'][this.currentYear][month[1]][2]
              && this.project_overview_amount['months'][this.currentYear][month[1]][2][this.division]) {
              dataLaboM[index] = this.project_overview_amount['months'][this.currentYear][month[1]][2][this.division];
            } else {
              dataLaboM[index] = 0;
            }
          });
          this.option.series[0].data = dataMaintainM;
          this.option.series[1].data = dataSpotM;
          this.option.series[2].data = dataLaboM;
          break;
        case 1:
          this.option.xAxis[0].data =
            ['Quý 1 - ' + this.currentYear, 'Quý 2 - ' + this.currentYear,'Quý 3 - ' + this.currentYear,'Quý 4 - ' + this.currentYear];
          let dataMaintainQ = [];
          let dataSpotQ = [];
          let dataLaboQ = [];
          Object.entries(this.quarters).forEach((quarter, index) => {
            if (this.project_overview_amount['quarters'][this.currentYear][quarter[1]]
              && this.project_overview_amount['quarters'][this.currentYear][quarter[1]][3]
              && this.project_overview_amount['quarters'][this.currentYear][quarter[1]][3][this.division]) {
              dataMaintainQ[index] = this.project_overview_amount['quarters'][this.currentYear][quarter[1]][3][this.division];
            } else {
              dataMaintainQ[index] = 0;
            }

            if (this.project_overview_amount['quarters'][this.currentYear][quarter[1]]
              && this.project_overview_amount['quarters'][this.currentYear][quarter[1]][1]
              && this.project_overview_amount['quarters'][this.currentYear][quarter[1]][1][this.division]) {
              dataSpotQ[index] = this.project_overview_amount['quarters'][this.currentYear][quarter[1]][1][this.division];
            } else {
              dataSpotQ[index] = 0;
            }

            if (this.project_overview_amount['quarters'][this.currentYear][quarter[1]]
              && this.project_overview_amount['quarters'][this.currentYear][quarter[1]][2]
              && this.project_overview_amount['quarters'][this.currentYear][quarter[1]][2][this.division]) {
              dataLaboQ[index] = this.project_overview_amount['quarters'][this.currentYear][quarter[1]][2][this.division];
            } else {
              dataLaboQ[index] = 0;
            }
          });
          this.option.series[0].data = dataMaintainQ;
          this.option.series[1].data = dataSpotQ;
          this.option.series[2].data = dataLaboQ;
          break;
        case 2:
          this.option.xAxis[0].data = this.labelYears;
          let dataMaintainY = [];
          let dataSpotY = [];
          let dataLaboY = [];
          Object.entries(this.listYear).forEach((year, index) => {
            if (this.project_overview_amount['years'][year[1]]
              & this.project_overview_amount['years'][year[1]][3]
              && this.project_overview_amount['years'][year[1]][3][this.division]) {
              dataMaintainY[index] = this.project_overview_amount['years'][year[1]][3][this.division];
            } else {
              dataMaintainY[index] = 0;
            }

            if (this.project_overview_amount['years'][year[1]]
              && this.project_overview_amount['years'][year[1]][1]
              && this.project_overview_amount['years'][year[1]][1][this.division]) {
              dataSpotY[index] = this.project_overview_amount['years'][year[1]][1][this.division];
            } else {
              dataSpotY[index] = 0;
            }

            if (this.project_overview_amount['years'][year[1]]
              && this.project_overview_amount['years'][year[1]][2]
              && this.project_overview_amount['years'][year[1]][2][this.division]) {
              dataLaboY[index] = this.project_overview_amount['years'][year[1]][2][this.division];
            } else {
              dataLaboY[index] = 0;
            }
          });
          this.option.series[0].data = dataMaintainY;
          this.option.series[1].data = dataSpotY;
          this.option.series[2].data = dataLaboY;
          break;
      }
    },
    async getData() {
      await this.getOverviewProjectAmount();
      let labelYears = [];
      let listYear = [];
      Object.keys(this.project_overview_amount['years']).forEach(year => {
        listYear.push(year);
        labelYears.push('Năm ' + year);
      })
      this.labelYears = labelYears;
      this.listYear = listYear;
    },
    onClickBarChart(e) {
      // maintain: 0 => 3, spot: 1 => 1, labo: 2 => 2
      const param = {
        status: 0,
        project_type: e.componentIndex === 0 ? 3 : e.componentIndex,
        department_code: this.division
      }
      // this.$router.push({name: 'projects', params: param});
    },
    resizeWidth() {
      const widthChart = document.getElementById('project_amount_chart').offsetWidth;
      if (widthChart >= 1500) {
        this.option.barWidth = 50;
      } else {
        this.option.barWidth = Math.floor(widthChart/30);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  .header {
    width: 100%;
    background: #17A896;
    border-radius: 10px;
    padding: 12px;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.0703846px;
    color: #FFFFFF;
  }
  #project_amount_params {
    display: flex;
    align-items: center;
    #project_amount_selects {
      display: flex;
      height: 72px;
      align-items: center;
      margin-left: 34px;
      border-right: 1px solid #DADADA;
      .project_amount_select {
        display: flex;
        align-items: center;
        margin-right: 12px;
        input {
          margin-right: 10px;
        }
        label {
          font-family: "Helvetica Neue", sans-serif;
          border: 1px solid #DADADA;
          border-radius: 10px;
          min-width: 100px;
          text-align: left;
          padding-left: 12px;
          height: 41px;
          line-height: 41px;
          font-weight: 400;
          font-size: 14px;
          margin-bottom: 0;
        }
      }
    }
    #year_select {
      margin-left: 14px;
      select {
        width: 151px;
        height: 41px;
        border: 1px solid #DADADA;
        border-radius: 8px;
        background-color: #FFFFFF;
        padding-left: 12px;
      }
    }
  }
  #project_amount_chart {
    display: flex;
    justify-content: center;
  }
}
</style>
